// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Minicart__error__root","action":"cmp-Minicart__error__action"};